import {Route} from 'react-router'
import {EditAdmin} from './admins/edit'
import {ManageAdmins} from './admins/index'
import {NewAdmin} from './admins/new'
import {ProtectedRoute} from '~/routing'

export const routes = (
	<Route path="/settings" element={<ProtectedRoute enableRole="admin" />}>
		<Route path="admins" element={<ManageAdmins />} />
		<Route path="admins/:id/edit" element={<EditAdmin />} />
		<Route path="admins/new" element={<NewAdmin />} />
	</Route>
)
